export const ID_TO_SEND = 'TO_SEND';
export const ID_SENT = 'SENT';
export const ID_ACCOUNTED = 'ACCOUNTED';
export const ID_UNACCOUNTED = 'UNACCOUNTED';